export default function Grain() {
  return <div aria-hidden className="grain fixed inset-0 z-[99] pointer-events-none" data-testid="grain-overlay" />;
}
